import { Theme } from '@teko/ui';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import { SiteMeta, TenantEnv } from 'types';

function MetaHead({
  theme,
  config,
  meta,
}: {
  theme: Theme;
  config: TenantEnv;
  meta: SiteMeta;
}): React.ReactElement {
  const { tenant, logoUrl, schemaWebsite, organizationSchema } = config;
  const router = useRouter();
  const { query } = router;

  const getIconUrl = (size: number) => `${logoUrl}=w${size}`;

  return (
    <Head>
      <title>{meta?.title}</title>
      <link
        rel="shortcut icon"
        href={logoUrl ? getIconUrl(16) : `/${tenant}/favicon.ico?`}
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={logoUrl ? getIconUrl(180) : `/${tenant}/apple-touch-icon.png?`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={logoUrl ? getIconUrl(32) : `/${tenant}/favicon-32x32.png?`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={logoUrl ? getIconUrl(16) : `/${tenant}/favicon-16x16.png?`}
      />
      <meta
        name="msapplication-TileColor"
        content={theme.brand.primary || '#ffffff'}
      />
      <meta name="theme-color" content={theme.brand.primary || '#ffffff'} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1.0, shrink-to-fit=no"
      />
      {schemaWebsite && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemaWebsite),
          }}
        />
      )}
      {organizationSchema && !query.slug && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(organizationSchema),
          }}
        />
      )}
    </Head>
  );
}

export default MetaHead;
